import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  eventName: '',
  eventId: 0,
  preorderStartDate: null,
  preorderEndDate: null,
  cityTax: null,
  stateTax: null,
  eventTaxes: null,
  eventNameDisplay: '',
  isAtAllEvents: false,
};

const currentEventSlice = createSlice({
  name: 'currentEvent',
  initialState,
  reducers: {
    setCurrentEvent: (state, action) => {
      const {
        eventName,
        eventId,
        preorderStartDate,
        preorderEndDate,
        cityTax,
        stateTax,
        eventTaxes,
        eventNameDisplay,
      } = action.payload || {};

      if (eventName !== undefined) state.eventName = eventName;
      if (eventId !== undefined) state.eventId = eventId ? parseInt(eventId, 10) : 0;
      if (preorderStartDate !== undefined) state.preorderStartDate = preorderStartDate;
      if (preorderEndDate !== undefined) state.preorderEndDate = preorderEndDate;
      if (cityTax !== undefined) state.cityTax = cityTax;
      if (stateTax !== undefined) state.stateTax = stateTax;
      if (eventTaxes !== undefined) state.eventTaxes = eventTaxes;
      if (eventNameDisplay !== undefined) state.eventNameDisplay = eventNameDisplay;
    },
    clearCurrentEvent: (state) => {
      state.eventName = '';
      state.eventId = 0;
      state.preorderStartDate = null;
      state.preorderEndDate = null;
      state.cityTax = null;
      state.stateTax = null;
      state.eventTaxes = null;
      state.eventNameDisplay = '';
    },
    setIsAtAllEvents: (state, action) => {
      state.isAtAllEvents = action.payload;
    },
  },
});

export const { setCurrentEvent, clearCurrentEvent, setIsAtAllEvents } = currentEventSlice.actions;
export default currentEventSlice.reducer;
